import { render, staticRenderFns } from "./CustomerServiceWidget.vue?vue&type=template&id=b0bcbfa0&scoped=true"
import script from "./CustomerServiceWidget.vue?vue&type=script&lang=js"
export * from "./CustomerServiceWidget.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceWidget.vue?vue&type=style&index=0&id=b0bcbfa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bcbfa0",
  null
  
)

export default component.exports